import { Api_EndPoints } from "../utils/Api_EndPoints";
import { useMutation, useQuery } from "@tanstack/react-query";
import http_payroll from "../utils/http_payroll";

const updateEmployeeLeave = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.UpdateEmployeeLeave,
    input,
  );
  return data;
};

const getEmpAllocatedLeaves = async ({
  companyCode,
  locationCode,
  employeeCode = 0,
  isAllCompanies = false,
  userId = 0,
  selectedCompanyCode = "",
}) => {
  if (companyCode && locationCode) {
    let queryString = `?IsAllCompanies=${isAllCompanies}&CompanyCode=${isAllCompanies ? selectedCompanyCode : companyCode}&LocationCode=${locationCode}`;
    if (employeeCode !== 0) {
      queryString += `&EmployeeCode=${employeeCode}`;
    }
    if (isAllCompanies) {
      queryString += `&UserId=${userId}`;
    }
    const { data } = await http_payroll.get(
      `${Api_EndPoints.GetEmpAllocatedLeave}${queryString}`,
    );
    return data;
  }
  return [];
};

export const useGetEmpAllocatedLeaveQuery = (companyCode) => {
  return useQuery({
    queryKey: [Api_EndPoints.GetEmpAllocatedLeave],
    queryFn: () => getEmpAllocatedLeaves(companyCode),
  });
};

export const useUpdateEmployeeLeave = () => {
  return useMutation({
    mutationFn: updateEmployeeLeave,
  });
};
